var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRuta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.818,
    height: 50,
    viewBox: "0 0 31.818 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_154",
    "data-name": "Trazado 154",
    d: "M5-6.944C5-16.2,11.726-23,20.909-23S36.818-16.2,36.818-6.944c0,7.068-2.47,14.836-6.5,22.371C26.869,21.864,23.041,27,20.909,27s-5.927-5.1-9.371-11.527C7.485,7.913,5,.124,5-6.944Zm15.911,28.56c.271-.33.568-.71.881-1.13a59.009,59.009,0,0,0,4.516-7.2C30.019,6.349,32.273-.74,32.273-6.944c0-6.758-4.7-11.51-11.364-11.51S9.545-13.7,9.545-6.944c0,6.2,2.269,13.312,6,20.269a59.209,59.209,0,0,0,4.5,7.173C20.35,20.914,20.643,21.289,20.911,21.616ZM14.091-7.091a6.583,6.583,0,0,1,6.818-6.818,6.583,6.583,0,0,1,6.818,6.818A6.583,6.583,0,0,1,20.909-.273,6.583,6.583,0,0,1,14.091-7.091Z",
    transform: "translate(-5 23)",
    fill: "#6a767d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_153",
    "data-name": "Trazado 153",
    d: "M0,30.545H54.545V-24H0Z",
    transform: "translate(0 24)",
    fill: "#6a767d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_129",
    "data-name": "Rect\\xE1ngulo 129",
    width: 54,
    height: 72,
    transform: "translate(0.363 0.364)",
    fill: "#6a767d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    "data-name": "Trazado 152",
    d: "M5,27H36.818V-23H5Z",
    transform: "translate(-5 23)",
    fill: "#6a767d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_295",
    "data-name": "Grupo 295",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_294",
    "data-name": "Grupo 294",
    transform: "translate(-11.364 -2.273)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_293",
    "data-name": "Grupo 293",
    transform: "translate(0 -9.091)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_292",
    "data-name": "Grupo 292",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_291",
    "data-name": "Grupo 291",
    transform: "translate(11.364 11.364)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    "data-name": "Trazado 151",
    d: "M0-28H54.545V44.727H0Z",
    transform: "translate(-11.364 16.636)",
    fill: "#6a767d"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRuta);
export default __webpack_public_path__ + "static/media/ico_ruta.e7aeaa9db2cc55f2dae1f06e4eb57988.svg";
export { ForwardRef as ReactComponent };